/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoLocationEntity } from './geoLocationEntity';
import { PromoEntity } from './promoEntity';


export interface CreateEventDto { 
    /**
     * External route URL for this activity
     */
    routeUrl?: string;
    acceptAnyLvl: boolean;
    handiFriendly?: boolean;
    addressName?: string;
    backgroundUrl?: string;
    description: string;
    distance: number;
    duration?: number;
    level: number;
    location: GeoLocationEntity;
    endLocation?: GeoLocationEntity;
    maxNbAttendees: number;
    /**
     * Optional minimum participants (organiser counted in, so two or more) that
     * confirms the activity. Added by hand for the same reason as the fields in
     * eventDetailOutputDto: `generate:sdk` needs a running API.
     */
    minParticipants?: number;
    attendeesMode?: CreateEventDto.AttendeesModeEnum;
    pace: string;
    sessionKindId: string;
    sportId: string;
    startDate: string;
    title: string;
    groupId?: string;
    verticalDrop?: number;
    privacy?: CreateEventDto.PrivacyEnum;
    repeatWeekly?: boolean;
    endDate?: string;
    type?: string;
    costPerParticipant?: number;
    isPaidOut?: boolean;
    commissionPercent?: number;
    listPromos?: Array<PromoEntity>;
    commissionId?: string;
    cgvId?: string;
}
export namespace CreateEventDto {
    export type AttendeesModeEnum = 'preset' | 'manual';
    export const AttendeesModeEnum = {
        Preset: 'preset' as AttendeesModeEnum,
        Manual: 'manual' as AttendeesModeEnum
    };
    export type PrivacyEnum = 'public' | 'private' | 'members_only';
    export const PrivacyEnum = {
        Public: 'public' as PrivacyEnum,
        Private: 'private' as PrivacyEnum,
        MembersOnly: 'members_only' as PrivacyEnum
    };
}


